import React, { useEffect, useState } from "react";

import AppIcon from "src/commun/composants/AppIcon";
import { AppNestedMenu, MenuItemData } from "fer-react-components";
import { useAppState } from "src/app/state/StateProvider";
import { getServiceIcon } from "src/commun/utils/iconUtils";
import { goToUrl } from "src/app/menu/menuutil";
import { useNavigate } from "react-router-dom";
import { useAppText } from "src/commun/composants/AppText";

const Applications = () => {
  const [state] = useAppState();

  const { tString } = useAppText();

  const navigate = useNavigate();

  const [menuItems, setMenuItems] = useState<MenuItemData>({
    leftIcon: <AppIcon title={tString("menu.application.title")} className={"cursor-pointer couleurIconBleu"} name="menu-application" size="26px"/>,
    items: [],
  });

  useEffect(() => {

    setMenuItems(menuItems => {
      menuItems.leftIcon = <AppIcon title={tString("menu.application.title")} className={"cursor-pointer couleurIconBleu"} name="menu-application" size="26px"/>;

      menuItems.items = (state.menu?.services || []).map(service => ({
        label: service.labels[state.langue],
        callback: () => goToUrl(service.url, service.openInNewTab, navigate),
        bottomDivider: true,
        leftIcon: <img src={getServiceIcon(state.menu?.imageBaseURl || "", service.code)} width="30" height="30" alt={service.labels[state.langue]}/>,
      }));

      return menuItems;
    });
  }, [state.menu?.services, state.langue, state.traductions]);

  return <AppNestedMenu menuItemsData={menuItems}/>;
};

export default Applications;
